import {
  DAYS_IN_YEAR,
  MONTHS_IN_YEAR,
  QUARTERS_IN_YEAR,
  WEEKS_IN_YEAR,
} from '../constants';

interface COMPOUND_CALCULATOR_PROPS {
  principleAmount: number | undefined;
  annualrate: number | undefined;
  periodInDigit: number | undefined;
  periodUnit: string | undefined;
  compoundFrequency: string | undefined;
}

export const COMPOUND_INTEREST_FORMULA = ({
  principleAmount,
  annualrate,
  periodInDigit,
  periodUnit,
  compoundFrequency,
}: COMPOUND_CALCULATOR_PROPS) => {
  if (
    !principleAmount ||
    !annualrate ||
    !periodInDigit ||
    !periodUnit ||
    !compoundFrequency ||
    Number(principleAmount) < 0 ||
    Number(annualrate) < 0 ||
    Number(periodInDigit) < 0
  ) {
    return {
      interestEarned: 0,
      resultPrincipalAmount: 0,
      totalValue: 0,
    };
  }

  let interestEarned = 0;
  const timeInYears = getTimeInYears(periodUnit, periodInDigit);
  const compoundFrequencyMultiplier =
    getCompoundFrequencyMultiplier(compoundFrequency);

  interestEarned = Number(
    (
      principleAmount *
        Math.pow(
          1 + annualrate / compoundFrequencyMultiplier / 100,
          timeInYears * compoundFrequencyMultiplier
        ) -
      principleAmount
    ).toFixed(2)
  );
  return {
    interestEarned,
    resultPrincipalAmount: principleAmount,
    principleAmount,
    totalValue: Number(interestEarned) + Number(principleAmount),
  };
};

export function getTimeInYears(periodUnit: string, periodInDigit: number) {
  switch (periodUnit) {
    case 'days':
      return periodInDigit / DAYS_IN_YEAR;
    case 'weeks':
      return periodInDigit / WEEKS_IN_YEAR;
    case 'months':
      return periodInDigit / MONTHS_IN_YEAR;
    case 'quarters':
      return periodInDigit / QUARTERS_IN_YEAR;
    default:
      return periodInDigit;
  }
}

function getCompoundFrequencyMultiplier(compoundFrequency: string) {
  switch (compoundFrequency) {
    case 'daily':
      return DAYS_IN_YEAR;
    case 'weekly':
      return WEEKS_IN_YEAR;
    case 'monthly':
      return MONTHS_IN_YEAR;
    case 'quaters':
      return QUARTERS_IN_YEAR;
    case 'semi-annually':
      return 2;
    case 'yearly':
      return 1;
    default:
      return 1;
  }
}
